import { hex_md5 } from '@/utils/md5'

const secret = {
    create: function (url) {
        var key1 = location.origin;
        var key2 = '4cbd7485e2823eaa75ed8eb5484525a7';
        var key3 = new Date().getTime().toString();

        // console.log('url', url)
        // console.log('key1', key1)
        // console.log('key2', key2)
        // console.log('key3', key3)
        // console.log('\r\n')

        var pA = key1 + key2;

        var key3Last = parseInt(key3[key3.length - 1]);
        key3Last = key3Last == 0 ? 1 : key3Last;

        var arr = pA;
        var newArr = [];
        for (let i = 0; i < arr.length; i++) {
            if (i % key3Last != 0) {
                newArr.push(arr[i]);
            }
        }

        var md5 = hex_md5(newArr.join(''));

        arr = md5;
        newArr = [];

        var j = 0;
        for (let i = 0; i < arr.length; i++) {
            newArr.push(arr[i]);
            if (j < key3.length) {
                newArr.push(key3[j]);
            }
            j++;
        }

        return newArr.join('') + key3.length.toString();
    }
};

export default secret